export class JSONParser {
    constructor(protected name: string) {}

    public parse<T>(input: any): T {
        try {
            return JSON.parse(input);
        } catch (error) {
            console.error(`[${this.name}]:`, error);
            return input;
        }
    }
}
